import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TransactionTypeEnum } from '../../transactions/enums/transaction-type.enum';
import { PaymentChannelEnum } from '../enums/payment-channel.enum';
import { PaymentMethodEnum } from '../enums/payment-method.enum';
import { PaymentProviderEnum } from '../enums/payment-provider.enum';
import type { PaymentTargetEnum } from '../enums/payment-target.enum';

import { ReservationInfoDto } from './reservation-info.dto';

/**
 * Initialize payment request DTO
 */
export class InitializePaymentRequestDto {
	/**
	 * The ID of the transaction that the payment is associated with.
	 * @description If not provided, a new transaction will be created.
	 */
	transactionId?: number;
	/**
	 * The type of the transaction that the payment is associated with.
	 * @description Used when creating a new transaction.
	 */
	type?: TransactionTypeEnum;
	provider!: PaymentProviderEnum;
	paymentMethod!: PaymentMethodEnum;
	channel!: PaymentChannelEnum;
	externalReference?: string;
	/**
	 * The target entity type for the payment
	 */
	target?: PaymentTargetEnum;
	/**
	 * The ID of the target entity
	 */
	targetId?: number;
	reference?: string;
	description?: string;
	reservationInfo?: ReservationInfoDto;
	@TransformFloat()
	amount?: number;
	@TransformInt()
	retryCount!: number;
	metadata?: Record<string, any>;
}
